import { render, staticRenderFns } from "./v-inbox-wrapper.vue?vue&type=template&id=1d4cb607&scoped=true&"
import script from "./v-inbox-wrapper.vue?vue&type=script&lang=js&"
export * from "./v-inbox-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./v-inbox-wrapper.vue?vue&type=style&index=0&id=1d4cb607&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4cb607",
  null
  
)

export default component.exports